import React from 'react'
import PropTypes from 'prop-types'
import universal from 'react-universal-component'
import { connect } from 'react-redux'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Helmet } from 'react-helmet'
import { ThemeProvider, DEAULT_THEME_MODE } from 'core/theme'
import { getCookieValue, setCookieValue } from 'utils/cookies'
import { Header, Footer } from 'modules'
import { breakpoints, defaultLayout } from 'core/layout'
import { LANGUAGES } from '../constants'

// NOTE: Nodrošina to, ka netiks iekļauts visos lapu fragmentos
import { momentDate } from 'utils/momentDate'

import Loading from './Loading'
import UniversalLoading from './UniversalLoading'
import NotFound from './NotFound'

import changeBreakpoint from '../actions/changeBreakpointActions'
import loadingStatuss from '../actions/LoadingActions'

import styles from '../css/Main'

const DEV = process.env.NODE_ENV === 'development'

// __isBrowser__ jau no webpaka iet
// šeit piemērs kā inportējam libus tikai client side, jo serverside nevar izpildīt darbības ar window, document ..
// const __isBrowser__ = typeof window !== 'undefined'
const enquire = __isBrowser__ ? require('enquire.js') : undefined
__isBrowser__ ? require('matchmedia-polyfill') : undefined
__isBrowser__
  ? require('matchmedia-polyfill/matchMedia.addListener')
  : undefined

const components = [
  'AktualiDefault',
  'DokumentiDefault',
  'DomeDefault',
  'IepirkumiDefault',
  'LiepajniekiemPostDefault',
  'NotFound',
  'PageBilzuGalerija',
  'PageCategory',
  'PageDefault',
  'PageDokumenti',
  'PageDomesDeputati',
  'PageDomesVadiba',
  'PageHome',
  'PageIepirkumi',
  'PageIzsoles',
  'PageJaunumi',
  'PageKontakti',
  'PageLiepajniekiem',
  'PagePasvaldibasKontakti',
  'PageProjekti',
  'PageRedirect',
  'PageSearch',
  'PageSitemap',
  'PageUznemejiem',
  'PostDefault',
  'UznemejiemPostDefault'
]

const UniversalComponent = universal(props => import(`./${props.activeComponent}`), {
  minDelay: 0,
  alwaysDelay: false,
  loadingTransition: false,
  loading: UniversalLoading,
  error: NotFound,
  // onLoad: (module, info, props, context) => {
  //   console.log(module)
  //   console.log(info)
  //   console.log(props)
  //   console.log(context)
  //    // context.store.replaceReducer({ ...otherReducers, foo: module.fooReducer })
  //   // context.store.dispatch({ type: 'INIT_ACTION_FOR_ROUTE', payload: { param: props.param } })
  // },
  onError: error => console.error(error)
})

let globalLoading = false


const QUERY = gql`
  query MainQuery($lang: String!, $path: [String]) {
    home_page: page(lang: "lv", path:"/"){
      seo_image
    }
    page(lang: $lang, path: $path) {
        _id
        path
        title
        title_tag
        description_tag
        seo_image
        robots
        content
        images {
          alt
          src
        }
        parent
        post_type
        template
        rewrite_id
        rewrite_url
        rewrite_source
        rewrite_target
        feedback
        relationship
        subpages
        date_created
        date_modified
        acf
    }
    teksti(lang: $lang, _id: "loading") {
        _id
        text
    }
  }
`

const queryOptions = {
  options: ({ lang, path }) => ({
    fetchPolicy: 'cache-first',
    variables: {
      lang,
      path
    }
  }),
  props: props => {
    const { data: {
      loading,
      teksti,
      home_page,
      page
    } } = props

    return {
      loading,
      teksti,
      home_page,
      page
    }
  }
}

let homePage = null;
let init_page = null
let activeComponent = 'PageHome'

class Main extends React.Component {
  static childContextTypes = {
    themeMode: PropTypes.string,
    fontSize: PropTypes.number
  };

  constructor(props) {
    super(props)

    this.state = Object.assign({}, {
      page: props.page && props.page[0] ? props.page[0] : null,
      loading: false,
      done: false,
      error: false,
      newData: false,
      redirect: null,
      themeMode: DEAULT_THEME_MODE,
      fontSize: 1
    })

    if (__isBrowser__) {
      // NOTE: Nedefinējot abas robežas (min un max) nenostrādā,
      // kā arī darbība jārezultē match handler funkcijā.
      let prevMatch
      let matchBreakpoint
      // NOTE: Garantēta augoša platuma secība
      const sortedBreakpoints = Object.keys(breakpoints).map(key => ({ label: key, width: breakpoints[key] }))
      .sort((a, b) => (a.width === b.width) ? 0 : (a.width > b.width) ? 1 : -1)
      // NOTE: Quick-fix, lai iesaistītu arī 'desktop' breakpointu,
      // ņemot vērā, ka to noteikšana balstās uz max-width
      sortedBreakpoints.push({
        label: 'desktop',
        width: 8192
      })
      sortedBreakpoints.map(bp => {
        const queryBreakpoint = prevMatch ?
          `(min-width: ${(prevMatch.width + 1) / 16}em) and (max-width: ${bp.width / 16}em)` :
          `(max-width: ${bp.width / 16}em)`
        enquire.unregister(queryBreakpoint)
        enquire.register(queryBreakpoint, {
          match: () => {
            props.changeBreakpoint(bp.label)
          }
        })
        prevMatch = bp
      })
    }

    if (DEV) {
      // props.history.listen(({pathname}) => (
      //   console.log(pathname)
      // ));
    }
  }


  componentDidCatch = (error, errorInfo) => {
    window.gtag && gtag('event', 'exception', {
      description: `${error.toString()} / Stack Trace: ${JSON.encode(errorInfo.componentStack)}`
    })
  }

  componentWillMount() {
    const { page, home_page, history } = this.props

    if (home_page && Array.isArray(home_page)) {
      homePage = home_page[0]
    }

    init_page = page && page[0] ? page[0] : null

    // REWRITE
    if (init_page) {
      if (init_page.rewrite_source && init_page.rewrite_source !== '') {
        // ja redirekts uz iekšējo lapu
        this.setState(prevState => Object.assign({}, prevState, {
          redirect: init_page.rewrite_id
        }))
        history.replace(init_page.rewrite_source)
      } else if (init_page.rewrite_url && init_page.rewrite_url !== '') {
        if (__isBrowser__) {
          window.open(
            init_page.rewrite_url,
            init_page.rewrite_target ? init_page.rewrite_target : '_blank'
          )
        }
      }
    }


    if (this.props.global_loading && this.props.global_loading[this.props.path] === true) {
      this.props.loadingStatuss({ _id: this.props.path, loading: false })
    }

    for (var i = 0; i < components.length; i++) {
      const preload_comp = universal(props => import(`./${components[i]}`))
      preload_comp.preload()
    }
  }

  componentDidMount() {
    // FIXME: Ja iestatījumus uzstādam konstruktorā,
    // krāsu režīms tiek piemērots tikai daļai elementu.
    const { themeMode, fontSize } = this._getInitialSiteSettings()
    if (themeMode !== this.state.themeMode) {
      this._setThemeMode(themeMode)
    }
    if (fontSize !== this.state.fontSize) {
      this._setFontSize({
        value: fontSize
      })
    }

    if (window.performance) {
      const perfData = window.performance.timing
      const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart

      window.gtag && gtag('event', 'timing_complete', {
        event_category: 'page_load_time',
        value: pageLoadTime,
        name: 'load'
      })
    }

    window.onbeforeprint = this._onBeforePrint
  }

  componentWillUnmount() {
    window.onbeforeprint = null
  }

  _onBeforePrint = () => {
    window.gtag && gtag('event', 'print')
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && nextProps.page && nextProps.page[0]) {
      // graphql ieladejies uzsetojam state
      // console.log(`%ccomponentWillReceiveProps`, 'background-color: #e17ca4; padding:2px 6px;')

      if (nextProps.global_loading[nextProps.path] === true) {
        nextProps.loadingStatuss({ _id: nextProps.path, loading: false })
      }

      this.setState(prevState => Object.assign({}, prevState, {
        newData: false,
        redirect: null,
        page: nextProps.page[0]
      }))
    } else if (nextProps.loading) {
      if (!nextProps.global_loading[nextProps.path] || nextProps.global_loading[nextProps.path] === false) {
        nextProps.loadingStatuss({ _id: nextProps.path, loading: true })
      }
    }
  }

  getChildContext() {
    return {
      themeMode: this.state.themeMode
    }
  }

  beforeChange = props => {
    const { isSync } = props
     // console.log('beforeChange')
    // console.log(props)
    if (!isSync) {
      this.setState(prevState => Object.assign({}, prevState, {
        loading: true,
        newData: false,
        error: false
      }))
    }
  }
  afterChange = props => {
    const { isSync, isServer, isMount } = props

    // console.log('afterChange')

    if (!isSync) {
      this.setState(prevState => Object.assign({}, prevState, {
        loading: false,
        newData: true,
        error: false
      }))
    } else if (!isServer && !isMount) {
      this.setState(prevState => Object.assign({}, prevState, {
        done: true,
        newData: true,
        error: false
      }))
    }
  }

  handleError = error => {
    this.setState(prevState => Object.assign({}, prevState, {
      error: true,
      newData: false,
      loading: false
    }))
  }

  _isLoading(element, index, array) {
    return element
  }


  _getInitialSiteSettings = () => {
    const themeMode = getCookieValue('themeMode', DEAULT_THEME_MODE)
    const fontSize = getCookieValue('fontSize', 1)
    return {
      themeMode,
      fontSize
    }
  }

  _setThemeMode = mode => {
    if (mode !== this.state.themeMode) {
      setCookieValue('themeMode', mode)
      this.setState(prevState => Object.assign({}, prevState, {
        themeMode: mode
      }))

      window.gtag && gtag('event', 'change_theme_mode', {
        event_category: 'accessibility',
        event_label: mode
      })
    }
  }

  _setFontSize = zoom => {
    if (zoom.value !== this.state.fontSize) {
      setCookieValue('fontSize', zoom.value)
      this.setState(prevState => Object.assign({}, prevState, {
        fontSize: zoom.value
      }), () => {
        const [html] = Array.from(document.getElementsByTagName('html')) || []
        if (html) {
          html.style.fontSize = `${16 * this.state.fontSize}px`
        }
      })

      window.gtag && gtag('event', 'change_font_size', {
        event_category: 'accessibility',
        event_label: zoom.value
      })
    }
  }


  render() {
    const {
      history,
      breakpoint,
      loading,
      page,
      teksti,
      ...rest
    } = this.props

    init_page = page && page[0] ? page[0] : null

    // cikls iziet cauri diviem loderiem
    // 1: props.loading - graphql loderis
    // 2: state.loading - universal loderis
    // 3: pieliku newData kad universal parsledzies

    const nextComponent = this.state.page ? `${this.state.page.post_type}${this.state.page.template ? this.state.page.template : 'Default'}` : '404'

    if (this.state.page && !this.state.loading && !loading && this.state.page._id != init_page._id && (this.state.newData || (activeComponent === nextComponent))) {
      init_page = this.state.page
    }

    if (activeComponent != nextComponent) {
      activeComponent = nextComponent
    }


    // nelaižam tālāk kamēr nav piepildījušies šie nosacījumi
    // || (__isBrowser__ && (!breakpoint || breakpoint===''))


    // console.log('props: ',this.props)
    // // sakuma caur prospiem ladejas graphql

    // console.log('state: ',this.state)
    // console.log('\n')

    // if(!init_page){
    //   return <Loading />
    // }

    // vai init_page ir uzsetots tiklidz notiek pirmais render?

    // FIXME: Nepieciešams mehānisms, kā atšķirt neesošu lapu!
    if (Array.isArray(page) && page.length === 0) {
      return <NotFound lang={this.props.lang} />
    }

    // ja ir uzsetots redirect, vai nav init_page
    if (!init_page || init_page && (this.state.redirect && this.state.redirect !== init_page._id)) {
      return <Loading teksti={teksti} />
    }


    const { global_loading } = this.props
    if (global_loading) {
      // NOTE: Analoga interpretācija bez Object.values, priekš IE11.
      // globalLoading = Object.values(global_loading).some(this._isLoading);
      globalLoading = Object.keys(global_loading).map(i => global_loading[i]).some(this._isLoading)
    }


    const _id = init_page ? init_page._id : undefined
    const path = init_page ? init_page.path : undefined
    const lang = this.props.lang
    // const lang = this.props.language[0]._id

    const locale = LANGUAGES.filter(language => language._id === lang)[0].locale


    /* console.log('--------------------------- render')
    console.log(init_page._id)
    console.log(global_loading)
    console.log(globalLoading)
    console.log('redirect ',this.state.redirect)
    console.log('state ',this.state.loading)
    console.log('props ',this.props.loading)
    console.log('newData ',this.state.newData)
    console.log('\n\n') */


    // // REWRITE
    // if (init_page) {
    //   if (init_page.rewrite_source && init_page.rewrite_source !== "") {
    //     // ja redirekts uz iekšējo lapu
    //     console.log('redirekts')
    //     history.replace(init_page.rewrite_source)
    //     init_page = null
    //     return null

    //   } else if (init_page.rewrite_url && init_page.rewrite_url !== "") {

    //     if (__isBrowser__) {
    //       window.open(
    //         init_page.rewrite_url,
    //         init_page.rewrite_target ? init_page.rewrite_target : '_blank'
    //       );
    //     }

    //   }
    // }


    __isBrowser__ ? console.log(`%cCOMPONENT | ${activeComponent} `, 'background-color: #d097ff; padding:2px 6px;') : null
    // console.log('%cRENDER', 'background-color: #FF95BE; padding:2px 6px;')
    // __isBrowser__?console.log('%cDEV:'+DEV, 'background-color: #daf22f; padding:2px 6px;'):null
    // console.log(this.props)

// console.log('-----')
// console.log(path)
// console.log(activeComponent)
// console.log('-----')

    const seo_image = init_page.seo_image || homePage.seo_image
    return (init_page) ? (
      <div>
      <Helmet>
        <title>
          {init_page.title_tag}
        </title>
        <meta name='description' content={init_page.description_tag} />
        <meta name='robots' content={init_page.robots} />

        <meta property='og:locale' content={locale} />
        <meta property='og:type' content='website' />
        <meta property='og:title' content={init_page.title_tag} />
        <meta property='og:description' content={init_page.description_tag} />
        <meta property='og:url' content={`https://www.liepaja.lv${path}`} />
        <meta property='og:site_name' content={init_page.title_tag} />
        {seo_image ? <meta property='og:image' content={seo_image} /> : null}
        {seo_image ? <meta property='og:image:width' content='1200' /> : null}
        {seo_image ? <meta property='og:image:height' content='400' /> : null}
        {seo_image ? <meta name='twitter:card' content='summary_large_image' /> : null}
        <meta name='twitter:description' content={init_page.description_tag} />
        <meta name='twitter:title' content={init_page.title_tag} />
        {seo_image ? <meta name='twitter:image' content={seo_image} /> : null}

      </Helmet>

      <ThemeProvider mode={this.state.themeMode}>

        {globalLoading ? <UniversalLoading teksti={teksti} /> : null}
        <Header
          onFontChange={this._setFontSize}
          onThemeChange={this._setThemeMode}
          path={init_page.path}
          activeLang={lang}
          forceRender={history.location.pathname}
          />
        <UniversalComponent
              history={history}
              postId={_id}
              path={this.props.path}
              init_page={init_page}
              skip={false} // varam noskipot graphql
              lang={lang}
              activeComponent={activeComponent}
              onBefore={this.beforeChange}
              onAfter={this.afterChange}
              onError={this.handleError} />
        <Footer lang={lang} path={this.props.path} feedback={(init_page.feedback === 'true')} />
      </ThemeProvider>
      </div>
    ) : <NotFound />
  }
}

const mapStateToProps = state =>
  // console.log(state)
   ({
    breakpoint: state.breakpoint,
    global_loading: state.global_loading
  })


const mapDispatchToProps = dispatch => ({
  changeBreakpoint: DEVICE => {
    dispatch(changeBreakpoint(DEVICE))
  },
  loadingStatuss: LOADING => {
    dispatch(loadingStatuss(LOADING))
  }
})

export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps, mapDispatchToProps)
)(Main)



// WEBPACK FOOTER //
// ./src/components/Main.js